import React from "react";

/* eslint-disable max-len */
export default function SlidePrevIcon() {
    return (
        <svg
            version="1.1"
            id="레이어_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 15.39 38.87"
            enableBackground="new 0 0 15.39 38.87"
            xmlSpace="preserve"
        >
            <g id="グループ_51" transform="translate(1881.148 1248.265)">
                <line
                    id="線_1-2"
                    fill="none"
                    stroke="#909090"
                    strokeWidth="4"
                    strokeLinecap="round"
                    x1="-1868.08"
                    y1="-1228.83"
                    x2="-1878.93"
                    y2="-1246.06"
                />

                <line
                    id="線_2-2"
                    fill="none"
                    stroke="#909090"
                    strokeWidth="4"
                    strokeLinecap="round"
                    x1="-1868.08"
                    y1="-1228.83"
                    x2="-1878.93"
                    y2="-1211.59"
                />
            </g>
        </svg>
    );
}
